export default __webpack_public_path__ + "images/CO.5f1493d.png";